// extracted by mini-css-extract-plugin
export var background = "Table-module--background--01016";
export var bold = "Table-module--bold--ef558";
export var cell = "Table-module--cell--2695d";
export var cellWithIcon = "Table-module--cellWithIcon--584c2";
export var check = "Table-module--check--2bedc";
export var description = "Table-module--description--834a6";
export var footer = "Table-module--footer--3a8eb";
export var header = "Table-module--header--8f8a7";
export var icon = "Table-module--icon--dec1c";
export var listItem = "Table-module--listItem--0d2a4";
export var listItemCheck = "Table-module--listItemCheck--b537d";
export var listItemCheckError = "Table-module--listItemCheckError--e20de";
export var listItemCheckSuccess = "Table-module--listItemCheckSuccess--314ed";
export var minus = "Table-module--minus--06dab";
export var modern = "Table-module--modern--b95c4";
export var small = "Table-module--small--7cbd1";
export var sticky = "Table-module--sticky--7ecfe";
export var subtext = "Table-module--subtext--d2c86";
export var table = "Table-module--table--5d365";
export var tag = "Table-module--tag--38595";